import React from "react";
import "./styles.css";
import Gallery from "./Gallery";

const Home = () => {
  return (
    <section>
      <Gallery />
    </section>
  );
};

export default Home;
